import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsHighlyComponent } from './simple-icons-highly.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsHighlyComponent ],
    exports:      [ SimpleIconsHighlyComponent ],
    bootstrap:    []
})
export class SimpleIconsHighlyModule {}
